/** Short haptic feedback for supported mobile browsers. */
export function hapticTap() {
  if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
    navigator.vibrate(12);
  }
}
